import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';

const GET_TRIAL_STATUS = gql`
  query GetTrialStatus {
    getTrialStatus {
      isInTrial
      isTrialExpired
      daysLeft
      shouldFreeze
      billingStatus
      currentPlan
      aiCallsUsed
      aiCallsLimit
      usageBillingEnabled
      subscriptionEndDate
      lookbackDays
    }
  }
`;

export interface TrialStatus {
  isInTrial: boolean;
  isTrialExpired: boolean;
  daysLeft: number;
  shouldFreeze: boolean;
  billingStatus: string;
  currentPlan: string;
  aiCallsUsed: number;
  aiCallsLimit: number;
  usageBillingEnabled: boolean;
  subscriptionEndDate?: Date;
  lookbackDays?: number | null;
}

export const useTrialStatus = () => {
  const { data, loading, error, refetch } = useQuery<{
    getTrialStatus: TrialStatus;
  }>(GET_TRIAL_STATUS, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  return {
    trialStatus: data?.getTrialStatus,
    loading,
    error,
    refetch,
    isInTrial: data?.getTrialStatus?.isInTrial || false,
    isTrialExpired: data?.getTrialStatus?.isTrialExpired || false,
    daysLeft: data?.getTrialStatus?.daysLeft || 0,
    shouldFreeze: data?.getTrialStatus?.shouldFreeze || false,
    billingStatus: data?.getTrialStatus?.billingStatus || 'trial',
    currentPlan: data?.getTrialStatus?.currentPlan || 'trial',
    aiCallsUsed: data?.getTrialStatus?.aiCallsUsed || 0,
    aiCallsLimit: data?.getTrialStatus?.aiCallsLimit || 1000,
    usageBillingEnabled: data?.getTrialStatus?.usageBillingEnabled || false,
    subscriptionEndDate: data?.getTrialStatus?.subscriptionEndDate,
    lookbackDays: data?.getTrialStatus?.lookbackDays ?? null,
  };
};
